/* chosen.directive.js */

"use strict";
/* globals angular */
module.exports = function ($timeout) {
    let __indexOf =
        [].indexOf ||
        function (item) {
            for (let i = 0, l = this.length; i < l; i++) {
                if (i in this && this[i] === item) {
                    return i;
                }
            }
            return -1;
        };

    let CHOSEN_OPTION_WHITELIST, NG_OPTIONS_REGEXP, isEmpty, snakeCase;
    NG_OPTIONS_REGEXP =
        /^\s*(.*?)(?:\s+as\s+(.*?))?(?:\s+group\s+by\s+(.*))?\s+for\s+(?:([$\w][$\w]*)|(?:\(\s*([$\w][$\w]*)\s*,\s*([$\w][$\w]*)\s*\)))\s+in\s+(.*?)(?:\s+track\s+by\s+(.*?))?$/;
    CHOSEN_OPTION_WHITELIST = [
        "noResultsText",
        "allowSingleDeselect",
        "disableSearchThreshold",
        "disableSearch",
        "enableSplitWordSearch",
        "inheritSelectClasses",
        "maxSelectedOptions",
        "placeholderTextMultiple",
        "placeholderTextSingle",
        "searchContains",
        "singleBackstrokeDelete",
        "displayDisabledOptions",
        "displaySelectedOptions",
        "width",
    ];
    snakeCase = function (input) {
        return input.replace(/[A-Z]/g, function ($1) {
            return "_" + $1.toLowerCase();
        });
    };
    isEmpty = function (value) {
        let key;
        if (angular.isArray(value)) {
            return value.length === 0;
        } else if (angular.isObject(value)) {
            for (key in value) {
                if (Object.hasOwn(value, key)) {
                    return false;
                }
            }
        }
        return true;
    };

    return {
        restrict: "A",
        require: "?ngModel",
        terminal: true,
        link: function (scope, element, attr, ngModel) {
            let chosen,
                defaultText,
                disableWithMessage,
                empty,
                initOrUpdate,
                match,
                options,
                origRender,
                removeEmptyMessage,
                startLoading,
                stopLoading,
                valuesExpr,
                viewWatch;
            element.addClass("localytics-chosen");
            options = scope.$eval(attr.chosen) || {};
            angular.forEach(attr, function (value, key) {
                if (__indexOf.call(CHOSEN_OPTION_WHITELIST, key) >= 0) {
                    return (options[snakeCase(key)] = scope.$eval(value));
                }
            });
            // removing disable attr because it breaks initial disabled state loading in glMultiSelect
            startLoading = function () {
                return element.addClass("loading").trigger("chosen:updated");
                //return element.addClass('loading').attr('disabled', true).trigger('chosen:updated');
            };
            stopLoading = function () {
                return element.removeClass("loading").trigger("chosen:updated");
                //return element.removeClass('loading').attr('disabled', false).trigger('chosen:updated');
            };
            chosen = null;
            defaultText = null;
            empty = false;
            initOrUpdate = function () {
                if (chosen) {
                    return element.trigger("chosen:updated");
                } else {
                    chosen = element.chosen(options).data("chosen");
                    return (defaultText = chosen.default_text);
                }
            };
            removeEmptyMessage = function () {
                empty = false;
                return element.attr("data-placeholder", defaultText);
            };
            disableWithMessage = function () {
                empty = true;
                return element
                    .attr("data-placeholder", chosen.results_none_found)
                    .trigger("chosen:updated");
            };
            if (ngModel) {
                origRender = ngModel.$render;
                ngModel.$render = function () {
                    origRender();
                    return initOrUpdate();
                };
                if (attr.multiple) {
                    viewWatch = function () {
                        return ngModel.$viewValue;
                    };
                    scope.$watch(viewWatch, ngModel.$render, true);
                }
            } else {
                initOrUpdate();
            }
            // Ensure initialization for dynamically compiled elements
            scope.$evalAsync(function () {
                initOrUpdate();
            });
            attr.$observe("disabled", function () {
                return element.trigger("chosen:updated");
            });
            if (attr.ngOptions && ngModel) {
                match = attr.ngOptions.match(NG_OPTIONS_REGEXP);
                valuesExpr = match[7];
                let timer;
                scope.$watchCollection(valuesExpr, function (newVal /*, oldVal*/) {
                    return (timer = $timeout(function () {
                        if (angular.isUndefined(newVal)) {
                            return startLoading();
                        } else {
                            if (empty) {
                                removeEmptyMessage();
                            }
                            stopLoading();
                            if (isEmpty(newVal)) {
                                return disableWithMessage();
                            }
                        }
                    }));
                });
                return scope.$on("$destroy", function (/*event*/) {
                    if (typeof timer !== "undefined" && timer !== null) {
                        return $timeout.cancel(timer);
                    }
                });
            }
        },
    };
};

/*Generated Injectables*/
module.exports.$inject=['$timeout'];